var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})(LogLevel || (LogLevel = {}));
class Logger {
    constructor(name, options) {
        this.logLevel = LogLevel.INFO;
        this.name = name;
        this.options = Object.assign(Object.assign({}, defaultLoggingOptions), options);
        // Keep track of the logger instances to update them from global
        // logging methods.
        instances.push(this);
    }
    getLogLevel() {
        return this.logLevel;
    }
    setLogLevel(logLevel) {
        if (typeof logLevel === 'string') {
            this.logLevel = logLevelStringConverter[logLevel];
            return;
        }
        this.logLevel = logLevel;
    }
    debug(...args) {
        this.log(LogLevel.DEBUG, ...args);
    }
    info(...args) {
        this.log(LogLevel.INFO, ...args);
    }
    warning(...args) {
        this.log(LogLevel.WARNING, ...args);
    }
    error(...args) {
        this.log(LogLevel.ERROR, ...args);
    }
    log(logLevel, ...args) {
        if (logLevel < this.logLevel)
            return;
        const method = consoleMethodConverter[logLevel];
        const groupBadge = this.getGroupBadge(logLevel);
        const messagePrefix = this.getMessagePrefix(logLevel);
        // eslint-disable-next-line no-console
        console[method](...groupBadge, messagePrefix, ...args);
    }
    getGroupBadge(logLevel) {
        const styles = [
            `background: ${consoleMethodColor[logLevel]}`,
            'border-radius: 0.5em',
            'color: white',
            'font-weight: bold',
            'padding: 2px 0.5em',
        ];
        const { group } = this.options;
        if (!group)
            return [];
        return [`%c${group}`, styles.join(';')];
    }
    getMessagePrefix(logLevel) {
        const parts = [];
        if (this.options.includeTimestamp) {
            const now = new Date().toISOString();
            parts.push(`[${now}]`);
        }
        if (this.options.includeName) {
            parts.push(`[${this.name}]`);
        }
        if (this.options.includeLogLevel ||
            (this.options.includeLogLevel === undefined && logLevel < LogLevel.INFO)) {
            parts.push(`[${logLevelToStringConverter[logLevel]}]`);
        }
        return parts.join(' ');
    }
}
function setLogLevel(logLevel) {
    instances.forEach((instance) => instance.setLogLevel(logLevel));
}
const defaultLoggingOptions = {
    includeName: true,
    includeTimestamp: true,
};
/**
 * A container for all logger instances.
 */
const instances = [];
const logLevelStringConverter = {
    debug: LogLevel.DEBUG,
    info: LogLevel.INFO,
    warning: LogLevel.WARNING,
    error: LogLevel.ERROR,
};
const logLevelToStringConverter = {
    [LogLevel.DEBUG]: 'debug',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARNING]: 'warning',
    [LogLevel.ERROR]: 'error',
};
const consoleMethodConverter = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARNING]: 'warn',
    [LogLevel.ERROR]: 'error',
};
const consoleMethodColor = {
    [LogLevel.DEBUG]: '#7F8C8D',
    [LogLevel.INFO]: '#3498DB',
    [LogLevel.WARNING]: '#F39C12',
    [LogLevel.ERROR]: '#C0392B',
};

export { LogLevel, Logger, setLogLevel };
//# sourceMappingURL=index.js.map
